import React from 'react'

const Spinner = () => {
  return (
    <div className='w-8 h-8 rounded-full animate-spin border-gray-400 border-4 border-t-black mt-16 mb-10 mx-auto' ></div>
  )
}

export default Spinner